


















import { OptionBtnWithMenu } from '../../core/models/util-models';
import { Component, Prop, Vue, Mixins, Emit } from 'vue-property-decorator';
import BtnMenuWithOptions from '../../core/components/BtnMenuWithOptions.vue';
import { tooltipSaveFarmingVersion } from '../indicators';
import { farmingTypesDict } from '../helpers';
import { getUrlFarmingChanges } from '../utils';
import { InsuranceServices } from '../api/InsuranceServices';
import { NotificationStoreHelper } from '../../core/mixins';
import { farmingVersionSave } from '../farming_models';
import ModalAddVersionName from './ModalAddVersionName.vue';
import { goToUrl } from '../../core/utils';


@Component({
  components: {
    BtnMenuWithOptions,
    ModalAddVersionName
  }
})
export default class ButtonFarmingSaveVersion extends Mixins(NotificationStoreHelper) {
  @Prop({ default: false }) isSowing: boolean;  
  @Prop({ default: '' }) farmingType: string;
  @Prop({ default: -1 }) ID: number;

//delete confirmation
  confirmationModal: boolean = false;
  visibleModalSaveVersion: boolean = false;
  modalConfirmationTitle: string = '';
  modalConfirmationBody: string = '';

  options: OptionBtnWithMenu[] = [
    { 
      value: 1,
      text: 'Historial de cambios', 
      type: 'button',
      loading: false,
      url: '',
      action: this.seeHistoryChanges,
      disabled: null,
      tooltip: '',
      color: 'info' 
    },
    { 
      value: 0, 
      text: 'Guardar estado actual', 
      type: 'button',
      url: '',
      loading: false,
      action: this.showModalSaveVersion,
      tooltip: this.getTooltipSaveVersion,
      disabled: null,
      color: 'success'
    },
  ]

  visibilityModalSaveVersion(value){
    this.visibleModalSaveVersion = value
  }

  showConfirmationDialog(title, msgBody) {
      this.modalConfirmationTitle = title;
      this.modalConfirmationBody = msgBody;
      this.confirmationModal = true;
  }

  
  get getTooltipSaveVersion(): string {
    return tooltipSaveFarmingVersion(
      farmingTypesDict[this.farmingType]
    );
  }

  getFarmingChangesUrl(){
    return getUrlFarmingChanges(
      this.ID,
      farmingTypesDict[this.farmingType]
    )
  }

 



  seeHistoryChanges(){
    goToUrl(this.getFarmingChangesUrl());
  }

  showModalSaveVersion(){
    this.visibilityModalSaveVersion(true);
  }

  saveFarmingVersion(versionName: string){
    this.options[1].loading = true;
    let versionConfig: farmingVersionSave = {
        id: this.ID,
        version_type: farmingTypesDict[this.farmingType],
        version_name: versionName
      }
    InsuranceServices.saveFarmingVersion(
      versionConfig
    ).then((res) => {
      this.options[1].loading = false;
      this.$_successAddRecipients(res.message);
      this.visibilityModalSaveVersion(false);
    }).catch((error) => { 
      this.options[1].loading = false;
      this.$_catchLoadingDialog({
            response: error.response.data || {},
            alternative_msg: 'No se pudo guardar la version'
        })
    })
  }


}

